export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'
export const DATE_FORMAT = 'DD-MM-YYYY'
